import ErrorFallback from 'Components/ErrorFallback'
import {
  VATDefinitionCreatePage,
  VATDefinitionEditPage,
  VATDefinitionListPage
} from 'Services/ProductManagement/Features/VATDefinition/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

export function VATDefinitionRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<VATDefinitionListPage />} />
        <Route path="create" element={<VATDefinitionCreatePage />} />
        <Route path=":id/edit" element={<VATDefinitionEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
